import { FC, useEffect, useState } from "react"
import { ICodesView } from "../codes"
import { MdEdit, MdDeleteForever } from "react-icons/md"
import { RxHeight, RxWidth, RxArrowUp } from "react-icons/rx"
import Moment from "react-moment"
import { IQrCode } from "../../models"
import { CiCompass1 } from "react-icons/ci"

export const TableView: FC<ICodesView> = (data) => {

    const [selected, setSelected] = useState<IQrCode>()

    useEffect(() => {
        if (selected) {
            data.generate?.(selected)
        }
        setSelected(undefined)
    }, [selected])
    
    return (
        <div className="border rounded-lg">
            <table className="border-collapse table-auto w-full text-sm">
                <thead>
                    <tr>
                        <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-left">
                            <div className="flex flex-row space-x-2 items-center">Description</div>
                        </th>
                        <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-left">
                            <div className="flex flex-row space-x-2 items-center">Position</div>
                        </th>
                        <th className="border-b border-r font-medium p-4 py-3 text-slate-400 text-left">
                            <div className="flex flex-row space-x-2 items-center">Date</div>
                        </th>
                        <th className="border-b font-medium p-4 py-3 text-slate-400 text-left" colSpan={2}>
                            <div className="flex flex-row space-x-2 items-center">Actions</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data?.codes?.map((item: IQrCode) =>
                        <tr key={item.id} className="cursor-pointer border-b last-of-type:border-b-0 hover:bg-gray-50">
                            <td className="border-r p-4 text-slate-500" onClick={() => setSelected(item)}>{item.description}</td>
                            <td className="border-r p-4 text-slate-500" onClick={() => setSelected(item)}>
                                <div className="flex flex-row gap-x-5">
                                    <div className="flex flex-row gap-x-2 items-center" title={`Latitude: ${item.latitude}`}>
                                        <RxHeight /> {item.latitude}
                                    </div>
                                    <div className="flex flex-row gap-x-2 items-center" title={`Longitude: ${item.longitude}`}>
                                        <RxWidth /> {item.longitude}
                                    </div>
                                    <div className="flex flex-row gap-x-2 items-center" title={`Altitude: ${item.altitude}`}>
                                        <RxArrowUp /> {item.altitude}
                                    </div>
                                    <div className="flex flex-row gap-x-2 items-center" title={`Heading: ${item.heading}`}>
                                        <CiCompass1 /> {item.heading}
                                    </div>
                                </div>
                            </td>
                            <td className="border-r last-of-type:border-r-0 p-4 text-slate-500" onClick={() => setSelected(item)}>
                                <Moment date={item.created} format="DD/MM/YYYY" />
                            </td>
                            <td className="border-r last-of-type:border-r-0 p-4 text-slate-500 hover:text-logo" onClick={() => data.edit?.(item)}>
                                <MdEdit size={20} title="Edit" className="mx-auto" />
                            </td>
                            <td className="border-r last-of-type:border-r-0 p-4 text-slate-500 hover:text-red-400" onClick={() => data.remove?.(item)}>
                                <MdDeleteForever size={20} title="Delete" className="mx-auto" />
                            </td>
                        </tr>    
                    )}
                </tbody>
            </table>
        </div>
    )
}